<template>
    <div class="row">
        <div class="col-12 bg-gray2">
            <div class="h4 mb-0">
                {{ dto.title }}
            </div>
            <p v-if="dto.subTitleText" v-safe-html="dto.subTitleText" />
        </div>

        <div class="col-12">
            <div class="row">
                <div
                    v-for="(item, itemIndex) in dto.items"
                    :key="(item && item.name) ? item.name : `CrossSellMobileOfferTile-${itemIndex}`"
                    class="my-1 col-11 col-sm-8 col-md-6 col-lg-5 col-xl-4"
                >
                    <MobileOfferTile
                        :offer="item"
                        :selected-mobile-offer-seo-id="'none'"
                        @select-offer="addMobileOfferInCart($event, item)"
                    />
                </div>
            </div>
        </div>

        <div v-if="dto.otherOffersLink" class="col-auto mb-1">
            <a
                :href="dto.otherOffersLink.url"
                :data-oevent-category="dto.otherOffersLink.tms.category"
                :data-oevent-action="dto.otherOffersLink.tms.action"
                :data-oevent-label="dto.otherOffersLink.tms.label"
                v-text="dto.otherOffersLink.label"
                class="ob1-link-arrow"
            />
        </div>
    </div>
</template>
<script>
import MobileOfferTile
    from "../../../orange/broadband/demands/showcase/internetandmobileoffers/components/MobileOfferTile.vue";
import {alignDivsHeightsByLine} from "../../../orange/broadband/utils/AlignDivHeightsUtil";

const listOfDivToAlign = [
    "mobile-banner", "mobile-title-align", "mobile-price-align", "mobile-promo", "mobile-odr", "mobile-attributes", "mobile-selection"
];

export default {
    name: 'CartPageCrossSellContent',
    components: {MobileOfferTile},
    props: {
        dto: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            resizeHandler: null
        };
    },
    mounted() {
        this.resizeHandler = () => {
            this.alignDisplayedDivs();
        }
        window.addEventListener("resize", this.resizeHandler);
        this.alignDisplayedDivs();
    },
    beforeDestroy() {
        if (this.resizeHandler) {
            window.removeEventListener("resize", this.resizeHandler);
        }
    },
    updated() {
        this.alignDisplayedDivs();
    },
    methods: {
        alignDisplayedDivs() {
            alignDivsHeightsByLine(listOfDivToAlign);
        },
        addMobileOfferInCart(event, _crossSellItem) {
            const actionUrl = this.dto.addOfferInCartUrl;
            const actionJsonFormParams = {
                id: event,
                deviceEan: undefined,
                universe: "MOBILE",
            };
            this.addMobileOfferInProgress();
            const addMobileOfferErrorsHandler = this.addMobileOfferErrorsHandler();
            const addMobileOfferSuccessHandler = this.addMobileOfferSuccessHandler();
            $.ajax({
                method: "POST",
                url: actionUrl,
                contentType: "application/json",
                data: JSON.stringify(actionJsonFormParams)
            })
                .done(addMobileOfferSuccessHandler)
                .fail(addMobileOfferErrorsHandler);
            return false;
        },
        addMobileOfferInProgress() {
            this.$emit('add-mobile-offer-in-progress')
        },
        addMobileOfferSuccessHandler() {
            return (response) => {
                this.$emit('add-mobile-offer-success', response)
            }
        },
        addMobileOfferErrorsHandler() {
            return (error) => {
                this.$emit('add-mobile-offer-error', error)
            }
        }
    }
}
</script>
